import { Skeleton } from "@mui/material";
import ContentLoader from "../ContentLoader/ContentLoader";
import EntityListSkeleton from "../EntityList/EntityListSkeleton";
import styles from "../EventSummary/EventSummary.module.css";

const EventBroaderContextSkeleton = () => {
  return (
    <>
      <ContentLoader type={"paragraph"} />
      <h4 className={styles["secondary-header"]}>
        <Skeleton variant="text" width="20%" height={30} />
      </h4>
      <EntityListSkeleton grids={2} itemsCount={4} showSecondary />
    </>
  );
};

export default EventBroaderContextSkeleton;
